import { Context, FC, PropsWithChildren } from "react";

export function createContextProvider<T>(
  context: Context<T>,
  useValue: () => T,
): FC<PropsWithChildren> {
  return function ContextProvider({ children }: PropsWithChildren) {
    const value = useValue();
    return <context.Provider value={value}>{children}</context.Provider>;
  };
}

export function createStaticContextProvider<T>(
  context: Context<T>,
  value: T,
): FC<PropsWithChildren> {
  return function ContextProvider({ children }: PropsWithChildren) {
    return <context.Provider value={value}>{children}</context.Provider>;
  };
}
